module.exports = __webpack_public_path__ + "static/img/lap02.99ea43c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/lap02.png
// module id = Uu3w
// module chunks = 11